<template>
  <header class="app-header">
    <div class="node-header-4-463-1">
      <router-link to="/debate" class="node-block-111-382-2" style="cursor: pointer;">
        <img :src="getAssetUrl('logo.png')" alt="Logo" class="logo-image" />
      </router-link>
      <router-link to="/debate" class="node-logo">白馬論壇 - 時事辯論競技所</router-link>
      <div class="header-spacer"></div>
      <div class="header-nav-group">
        <nav class="nav-menu">
          <router-link 
            to="/" 
            class="nav-link" 
            :class="{ active: $route.path === '/' }"
          >
            首頁
          </router-link>
          <router-link 
            to="/debate" 
            class="nav-link" 
            :class="{ active: $route.path.startsWith('/debate') }"
          >
            辯論大廳
          </router-link>
          <button 
            v-if="isLoggedIn"
            class="header-message-btn nav-message-btn" 
            @click="showNotAvailableModal = true"
            aria-label="訊息"
          >
            <img :src="getAssetUrl('header/header_message.svg')" alt="Message" class="header-message-icon" />
          </button>
        </nav>
        <div class="header-auth-container">
          <router-link v-if="!isLoggedIn" to="/login" class="header-auth-link">
            <img :src="getAssetUrl('4_470.svg')" alt="Header Auth" class="header-auth" />
          </router-link>
          <router-link v-else to="/profile" class="header-auth-link">
            <img :src="getAssetUrl('header/header_user.svg')" alt="User" class="header-user-icon" />
          </router-link>
        </div>
      </div>
      <BaseModal
        :show="showNotAvailableModal"
        title="提示"
        message="功能尚未開放，請稍後再試。"
        :buttons="[{ label: '好的', type: 'primary', onClick: () => showNotAvailableModal = false }]"
        @update:show="showNotAvailableModal = $event"
      />
    </div>
  </header>
</template>

<script setup>
import { computed, onMounted, ref } from 'vue';
import { getAssetUrl } from '@/utils/getAssetUrl.js';
import { useUserStore } from '@/store/user.js';
import BaseModal from './BaseModal.vue';

// 直接使用 Pinia Store
const userStore = useUserStore();

// 計算屬性：從 store 取得登入狀態
const isLoggedIn = computed(() => userStore.isLoggedIn);

// 訊息按鈕的彈窗狀態
const showNotAvailableModal = ref(false);

// 初始化時檢查登入狀態
onMounted(() => {
  userStore.checkLogin();
});
</script>

<style scoped>
/* 頁首容器 */
.app-header {
  width: 100%;
  background-color: #ffffff;
  box-shadow: none;
}

.node-header-4-463-1 {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 24px;
  padding: 32px;
  border: none;
  border-bottom: 1px solid #000000;
  box-shadow: none;
  width: 100%;
  max-width: 1440px;
  margin: 0 auto;
}

/* 讓 nav-menu 與 header-auth-container 靠近一些 */
.header-nav-group {
  display: flex;
  align-items: center;
  gap: 12px; /* 减小 nav-menu 和 header-auth-container 之间的间距 */
  flex-shrink: 0;
  margin-left: auto; /* 靠右对齐 */
}

.node-block-111-382-2 {
  width: 40px;
  height: 35px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.logo-image {
  width: 100%;
  height: auto;
  object-fit: contain;
  display: block;
}

.node-logo {
  font-size: 24px;
  font-weight: 700;
  color: rgb(0, 0, 0);
  white-space: nowrap;
  flex-shrink: 1;
  text-decoration: none;
  cursor: pointer;
  transition: opacity 0.2s;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
}

.node-logo:hover {
  opacity: 0.8;
}

.header-spacer {
  flex: 1;
  min-width: 0;
  flex-shrink: 1;
}

.nav-menu {
  display: flex;
  ，，: 24px;
  align-items: center;
  flex-shrink: 0;
  white-space: nowrap;
}

.nav-link {
  font-size: 16px;
  color: rgb(0, 0, 0);
  text-decoration: none;
  cursor: pointer;
  padding: 8px 16px;
  border-radius: 4px;
  transition: background-color 0.2s;
}

.nav-link:hover {
  background-color: #f5f5f5;
}

.nav-menu .nav-link.active,
.nav-menu .nav-link.router-link-active,
.nav-menu .nav-link.router-link-exact-active {
  font-weight: 700 !important;
  color: rgb(0, 0, 0) !important;
  background: #ffffff !important;
  background-color: #ffffff !important;
  background-image: none !important;
  box-shadow: none !important;
}

.header-auth-container {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-shrink: 0;
  margin-left: 0; /* 移除额外的左边距 */
}

.header-auth-link {
  display: block;
  text-decoration: none;
  line-height: 0; /* 移除 SVG 下方的空白 */
}

.header-auth {
  display: block;
  object-fit: contain;
  flex-shrink: 0;
}

.header-message-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  background: transparent;
  border: none;
  cursor: pointer;
  transition: transform 0.2s ease, opacity 0.2s ease;
  line-height: 0; /* 移除 SVG 下方的空白 */
}

.header-message-btn:hover {
  transform: scale(1.05);
  opacity: 0.9;
}

.header-message-btn:active {
  transform: scale(0.95);
}

.nav-message-btn {
  padding: 8px;
  border-radius: 4px;
  transition: background-color 0.2s;
}

.nav-message-btn:hover {
  background-color: #f5f5f5;
  transform: scale(1.05);
  opacity: 0.9;
}

.header-message-icon {
  display: block;
  width: 32px;
  height: 32px;
  object-fit: contain;
  flex-shrink: 0;
}

.header-user-icon {
  display: block;
  width: 134px;
  height: 32px;
  object-fit: contain;
  flex-shrink: 0;
}

/* 圖片通用樣式 */
img {
  max-width: 100%;
  height: auto;
  display: block;
}

/* 響應式設計 */
@media (max-width: 1024px) {
  .node-header-4-463-1 {
    gap: 16px;
    padding: 24px;
  }

  .node-logo {
    font-size: 20px;
    flex-shrink: 1;
    min-width: 0;
  }

  .header-spacer {
    flex: 0 1 auto;
    min-width: 16px;
  }

  .nav-menu {
    gap: 16px;
    flex-shrink: 0;
  }

  .nav-link {
    padding: 6px 12px;
    font-size: 15px;
  }

  .header-auth-container {
    gap: 10px;
  }

  .header-user-icon {
    width: 100px;
    height: 24px;
  }

  .header-message-icon {
    width: 28px;
    height: 28px;
  }
}

@media (max-width: 768px) {
  .node-header-4-463-1 {
    gap: 12px;
    padding: 16px 20px;
    flex-wrap: nowrap; /* 防止换行 */
  }

  .node-logo {
    font-size: 18px;
    display: none; /* 在小屏幕时隐藏标题，让导航按钮利用空间 */
  }

  .header-spacer {
    display: none; /* 隐藏 spacer，让导航按钮直接利用左侧空间 */
  }

  .nav-menu {
    gap: 12px;
    flex: 1; /* 让导航菜单利用可用空间 */
    justify-content: flex-end; /* 靠右对齐，但可以利用左侧空间 */
    min-width: 0; /* 允许缩小 */
  }

  .nav-link {
    padding: 6px 10px;
    font-size: 14px;
    white-space: nowrap;
    flex-shrink: 0; /* 防止按钮文字被压缩 */
  }

  .header-auth-container {
    gap: 8px;
  }

  .header-user-icon {
    width: 80px;
    height: 20px;
  }

  .header-message-icon {
    width: 24px;
    height: 24px;
  }
}

@media (max-width: 480px) {
  .node-header-4-463-1 {
    gap: 8px;
    padding: 12px 16px;
  }

  .nav-menu {
    gap: 8px;
  }

  .nav-link {
    padding: 4px 8px;
    font-size: 13px;
  }

  .header-auth-container {
    gap: 6px;
  }

  .header-user-icon {
    width: 70px;
    height: 18px;
  }

  .header-message-icon {
    width: 20px;
    height: 20px;
  }
}
</style>
